import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-event-timeline',
  templateUrl: './event-timeline.component.html',
  styleUrls: ['./event-timeline.component.css']
,
  standalone: false
})
export class EventNewTimelineComponent implements OnInit {
  // Date range variables
  startDate: Date = new Date(); // Start date
  endDate: Date = new Date(new Date().setDate(this.startDate.getDate() + 13)); // Example: 14-day range

  // Timeline data
  timelineData: any[] = [];

  // Example motion events (to be replaced by API data)
  events = [
    { date: '2024-11-13', hour: '08:00', position: '50%' },
    { date: '2024-11-13', hour: '14:00', position: '30%' },
    { date: '2024-11-14', hour: '06:00', position: '70%' },
  ];

  ngOnInit() {
    const timelineData = [
        {
          date: 'Nov 19',
          hours: [
            { time: '00:00', events: [{ position: '20%', image: 'https://pro-fit-views.pro-vigil.info/api/SnapShot?channel=762430CAM1727376462&withmd=true&station=recordingStation791&farm=8457', details: 'Event 5 details'  }] },
            { time: '01:00', events: [] },
            { time: '02:00', events: [{ position: '50%' }] }, // Event at 02:30
            { time: '03:00', events: [] },
            { time: '04:00', events: [{ position: '20%' }] }, // Event at 04:12
            { time: '05:00', events: [{ position: '80%' }] }, // Event at 05:48
            { time: '06:00', events: [] },
            { time: '07:00', events: [{ position: '40%', image: 'https://pro-fit-views.pro-vigil.info/api/SnapShot?channel=762430CAM1727376462&withmd=true&station=recordingStation680&farm=8457', details: 'Event 1 details'  }] }, // Event at 07:24
            { time: '08:00', events: [] },
            { time: '09:00', events: [] },
            { time: '10:00', events: [{ position: '10%', image: 'https://pro-fit-views.pro-vigil.info/api/SnapShot?channel=762430CAM1727376462&withmd=true&station=recordingStation791&farm=8457', details: 'Event 1 details'  }] }, // Event at 10:06
            { time: '11:00', events: [] },
            { time: '12:00', events: [] },
            { time: '13:00', events: [{ position: '70%', image: 'https://pro-fit-views.pro-vigil.info/api/SnapShot?channel=762430CAM1727376462&withmd=true&station=recordingStation791&farm=8457', details: 'Event 2 details'  }] }, // Event at 13:42
            { time: '14:00', events: [] },
            { time: '15:00', events: [] },
            { time: '16:00', events: [{ position: '30%', image: 'https://pro-fit-views.pro-vigil.info/api/SnapShot?channel=762430CAM1727376462&withmd=true&station=recordingStation791&farm=8457', details: 'Event 3 details'  }] }, // Event at 16:18
            { time: '17:00', events: [] },
            { time: '18:00', events: [] },
            { time: '19:00', events: [{ position: '90%', image: 'https://pro-fit-views.pro-vigil.info/api/SnapShot?channel=762430CAM1727376462&withmd=true&station=recordingStation791&farm=8457', details: 'Event 4 details'  }] }, // Event at 19:54
            { time: '20:00', events: [] },
            { time: '21:00', events: [{ position: '50%', image: 'https://pro-fit-views.pro-vigil.info/api/SnapShot?channel=762430CAM1727376462&withmd=true&station=recordingStation791&farm=8457', details: 'Event 5 details'  }] }, // Event at 21:30
            { time: '22:00', events: [] },
            { time: '23:00', events: [{ position: '50%', image: 'https://pro-fit-views.pro-vigil.info/api/SnapShot?channel=762430CAM1727376462&withmd=true&station=recordingStation791&farm=8457', details: 'Event 5 details'  }] },
          ],
        },
        {
            date: 'Nov 20',
            hours: [
              { time: '00:00', events: [{ position: '50%', image: 'https://pro-fit-views.pro-vigil.info/api/SnapShot?channel=762430CAM1727376462&withmd=true&station=recordingStation791&farm=8457', details: 'Event 5 details'  }] },
              { time: '01:00', events: [] },
              { time: '02:00', events: [{ position: '50%' }, { position: '25%' },  { position: '75%' },  { position: '10%' }] }, // Event at 02:30
              { time: '03:00', events: [] },
              { time: '04:00', events: [{ position: '20%' }] }, // Event at 04:12
              { time: '05:00', events: [{ position: '80%' }] }, // Event at 05:48
              { time: '06:00', events: [] },
              { time: '07:00', events: [{ position: '40%', image: 'https://pro-fit-views.pro-vigil.info/api/SnapShot?channel=762430CAM1727376462&withmd=true&station=recordingStation680&farm=8457', details: 'Event 1 details', selected: false  }] }, // Event at 07:24
              { time: '08:00', events: [] },
              { time: '09:00', events: [] },
              { time: '10:00', events: [{ position: '10%', image: 'https://pro-fit-views.pro-vigil.info/api/SnapShot?channel=762430CAM1727376462&withmd=true&station=recordingStation791&farm=8457', details: 'Event 1 details', selected: false  }] }, // Event at 10:06
              { time: '11:00', events: [] },
              { time: '12:00', events: [] },
              { time: '13:00', events: [{ position: '70%', image: 'https://pro-fit-views.pro-vigil.info/api/SnapShot?channel=762430CAM1727376462&withmd=true&station=recordingStation791&farm=8457', details: 'Event 2 details', selected: true  }] }, // Event at 13:42
              { time: '14:00', events: [] },
              { time: '15:00', events: [] },
              { time: '16:00', events: [{ position: '30%', image: 'https://pro-fit-views.pro-vigil.info/api/SnapShot?channel=762430CAM1727376462&withmd=true&station=recordingStation791&farm=8457', details: 'Event 3 details'  }] }, // Event at 16:18
              { time: '17:00', events: [] },
              { time: '18:00', events: [] },
              { time: '19:00', events: [{ position: '90%', image: 'https://pro-fit-views.pro-vigil.info/api/SnapShot?channel=762430CAM1727376462&withmd=true&station=recordingStation791&farm=8457', details: 'Event 4 details'  }] }, // Event at 19:54
              { time: '20:00', events: [] },
              { time: '21:00', events: [{ position: '50%', image: 'https://pro-fit-views.pro-vigil.info/api/SnapShot?channel=762430CAM1727376462&withmd=true&station=recordingStation791&farm=8457', details: 'Event 5 details'  }] }, // Event at 21:30
              { time: '22:00', events: [] },
              { time: '23:00', events: [{ position: '50%', image: 'https://pro-fit-views.pro-vigil.info/api/SnapShot?channel=762430CAM1727376462&withmd=true&station=recordingStation791&farm=8457', details: 'Event 5 details'  }] },
            ],
          },    
          {
            date: 'Nov 21',
            hours: [
              { time: '00:00', events: [{ position: '50%', image: 'https://pro-fit-views.pro-vigil.info/api/SnapShot?channel=762430CAM1727376462&withmd=true&station=recordingStation791&farm=8457', details: 'Event 5 details'  }] },
              { time: '01:00', events: [] },
              { time: '02:00', events: [{ position: '50%' }, { position: '25%' },  { position: '75%' },  { position: '10%' }] }, // Event at 02:30
              { time: '03:00', events: [] },
              { time: '04:00', events: [{ position: '20%' }] }, // Event at 04:12
              { time: '05:00', events: [{ position: '80%' }] }, // Event at 05:48
              { time: '06:00', events: [] },
              { time: '07:00', events: [{ position: '40%', image: 'https://pro-fit-views.pro-vigil.info/api/SnapShot?channel=762430CAM1727376462&withmd=true&station=recordingStation680&farm=8457', details: 'Event 1 details', selected: false  }] }, // Event at 07:24
              { time: '08:00', events: [] },
              { time: '09:00', events: [] },
              { time: '10:00', events: [{ position: '10%', image: 'https://pro-fit-views.pro-vigil.info/api/SnapShot?channel=762430CAM1727376462&withmd=true&station=recordingStation791&farm=8457', details: 'Event 1 details', selected: false  }] }, // Event at 10:06
              { time: '11:00', events: [] },
              { time: '12:00', events: [] },
              { time: '13:00', events: [{ position: '70%', image: 'https://pro-fit-views.pro-vigil.info/api/SnapShot?channel=762430CAM1727376462&withmd=true&station=recordingStation791&farm=8457', details: 'Event 2 details', selected: true  }] }, // Event at 13:42
              { time: '14:00', events: [] },
              { time: '15:00', events: [] },
              { time: '16:00', events: [{ position: '30%', image: 'https://pro-fit-views.pro-vigil.info/api/SnapShot?channel=762430CAM1727376462&withmd=true&station=recordingStation791&farm=8457', details: 'Event 3 details'  }] }, // Event at 16:18
              { time: '17:00', events: [] },
              { time: '18:00', events: [] },
              { time: '19:00', events: [{ position: '90%', image: 'https://pro-fit-views.pro-vigil.info/api/SnapShot?channel=762430CAM1727376462&withmd=true&station=recordingStation791&farm=8457', details: 'Event 4 details'  }] }, // Event at 19:54
              { time: '20:00', events: [] },
              { time: '21:00', events: [{ position: '50%', image: 'https://pro-fit-views.pro-vigil.info/api/SnapShot?channel=762430CAM1727376462&withmd=true&station=recordingStation791&farm=8457', details: 'Event 5 details'  }] }, // Event at 21:30
              { time: '22:00', events: [] },
              { time: '23:00', events: [{ position: '50%', image: 'https://pro-fit-views.pro-vigil.info/api/SnapShot?channel=762430CAM1727376462&withmd=true&station=recordingStation791&farm=8457', details: 'Event 5 details'  }] },
            ],
          },   
      ];
      this.timelineData = timelineData;
   // this.generateTimelineData();
  }

  calculateEventPosition(time: string): string {
    const [hour, minute] = time.split(':').map(Number); // Split time into hours and minutes
    const percentage = (minute / 60) * 100; // Calculate percentage of the hour
    return `${percentage}%`; // Return percentage as a string with %
  }
  
  // Example of processing the data dynamically
  processTimelineData(rawData: any[]) {
    return rawData.map((day) => ({
      ...day,
      hours: day.hours.map((hour) => ({
        ...hour,
        events: hour.events.map((event) => ({
          ...event,
          position: this.calculateEventPosition(event.time),
        })),
      })),
    }));
  }
  
  // Generate dynamic timeline data
  generateTimelineData() {
    const timeline = [];
    let currentDate = new Date(this.startDate);

    while (currentDate <= this.endDate) {
      const day = {
        date: new Date(currentDate),
        hours: this.generateHourlyData(currentDate),
      };
      timeline.push(day);

      // Move to the next day
      currentDate.setDate(currentDate.getDate() + 1);
    }

    this.timelineData = timeline;
  }

    hoveredEvent: any = null; // Event hovered over
    selectedEvent: any = null; // Event clicked on

    showPopup(event: any): void {
    this.hoveredEvent = event;
    }

    hidePopup(): void {
    this.hoveredEvent = null;
    }

    showDetails(event: any): void {
    this.selectedEvent = event;
    }

    closePopup(): void {
    this.selectedEvent = null;
    }

    generateQuarterMarkers(): string[] {
        // Each hour has 4 markers: 15, 30, 45, and 60 minutes (divided equally within 100%)
        return ['25%', '50%', '75%'];
      }

    selectedEvents: any[] = [];
    toggleEventSelection(event: any, eventObj: Event) {
        event.selected = (eventObj.target as HTMLInputElement).checked;

        // Add or remove from the selectedEvents array
        if (event.selected) {
            this.selectedEvents.push(event);
        } else {
            this.selectedEvents = this.selectedEvents.filter(
            (selected) => selected !== event
            );
        }
    }
  // Generate hourly data for a day
  generateHourlyData(date: Date) {
    const hours = [];
    for (let i = 0; i < 24; i++) {
      const time = `${i.toString().padStart(2, '0')}:00`;
      const hourEvents = this.events
        .filter(
          (event) =>
            event.date === this.formatDate(date) && event.hour === time
        )
        .map((event) => ({
          position: event.position,
        }));

      hours.push({ time, events: hourEvents });
    }
    return hours;
  }

  // Utility: Format date to 'YYYY-MM-DD'
  formatDate(date: Date): string {
    return date.toISOString().split('T')[0];
  }

  // Zoom Controls
  zoomIn() {
    console.log('Zoom In');
    // Add zoom-in logic (e.g., increase time slot width)
  }

  zoomOut() {
    console.log('Zoom Out');
    // Add zoom-out logic (e.g., decrease time slot width)
  }
}